module.exports = __webpack_public_path__ + "static/img/hifi.5250e39.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/online-acc-registration/hifi.gif
// module id = HG2H
// module chunks = 1